// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footerMenuGroup-m__wrapper__26G78","footer-menu-item":"footerMenuGroup-m__footer-menu-item__3Ad_V"};